/** IndexedDB-Ablage für laufende Uploads: Dateien überleben Neuladen/Serverausfall und werden danach fortgesetzt. */
const DB_NAME = "inbox-uploads";
const STORE = "pending";

function open() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") return reject(new Error("no idb"));
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: "id" });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  try {
    const db = await open();
    return await new Promise((resolve, reject) => {
      const t = db.transaction(STORE, mode);
      const req = fn(t.objectStore(STORE));
      t.oncomplete = () => resolve(req?.result);
      t.onerror = () => reject(t.error);
    });
  } catch (e) {
    return undefined;
  }
}

export const uploadStore = {
  put: (row) => tx("readwrite", (s) => s.put(row)),
  remove: (id) => tx("readwrite", (s) => s.delete(id)),
  all: async () => (await tx("readonly", (s) => s.getAll())) || [],
};
